<template>
    <div class="integrations">
        <router-link to="/profile/integration/telegram" class="integration-card">
            <div class="icon">
                <img src="https://telegram.org/img/t_logo.png" alt="Telegram Logo" />
            </div>
            <div class="content">
                <h2>
                    Telegram Bot
                    <a
                        href="https://t.me/ChameleonOohdeskBot"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="bot-link"
                        @click.stop
                    >
                        @ChameleonOohdeskBot
                    </a>
                </h2>
                <p>Получайте системные уведомления напрямую в Telegram.</p>
            </div>
        </router-link>
    </div>
</template>

<script>

export default {
    name: "PageIntegrations"
};
</script>

<style lang="scss" scoped>
.integrations {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
}

.title {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 2rem;
}

.integration-card {
    display: flex;
    align-items: center;
    background: #f4f4f5;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: 0.3s ease;
    gap: 1.5rem;
    text-decoration: none;
    color: inherit;

    &:hover {
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
        background: #e9e9eb;
    }

    .icon img {
        width: 64px;
        height: 64px;
        border-radius: 12px;
    }

    .content {
        flex: 1;

        h2 {
            font-size: 1.25rem;
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 0.5rem;

            .bot-link {
                font-size: 1rem;
                color: #229ed9;
                text-decoration: none;
                font-weight: 600;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        p {
            margin: 0;
        }
    }
}
</style>
